import { render, staticRenderFns } from "./BirthdaysPrograms.vue?vue&type=template&id=2ce09381&scoped=true&"
import script from "./BirthdaysPrograms.vue?vue&type=script&lang=ts&"
export * from "./BirthdaysPrograms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce09381",
  null
  
)

export default component.exports